import { toast } from "sonner";

export async function sharePhoto(p) {
  const origin = window.location.origin;
  const url = p.id ? `${origin}/api/share/gallery/${p.id}` : `${origin}/gallery`;
  const text = `Check out this install by Dr.Gadget — ${p.title}. Book a session at ${origin}/book`;
  if (navigator.share) {
    try { await navigator.share({ title: `Dr.Gadget · ${p.title}`, text, url }); return; } catch { return; /* user cancelled */ }
  }
  try { await navigator.clipboard.writeText(`${text}\n${url}`); toast.success("Link copied — paste it into a text or email"); }
  catch { toast.error("Couldn't copy — the address is " + url); }
}
